
export enum SubscriptionStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
  TRIAL = 'trial',
}

export enum UserType {
  SUPER_ADMIN = "superAdmin",
  SUB_ADMIN = "subAdmin",
  USER = "user"
}

export enum IManagementStatus {
    INREVIEW= 'in_review',
    PUBLISHED= 'published',
    REJECTED= 'rejected',
    DRAFT= 'draft',
};

export enum CampaignType {
  CATCH = 'catch',
  INVITE = 'invite'
}

export enum CampaignTabs {
  CATCH = 'Catch Data',
  INVITE = 'Invite Friends'
}

export enum ICampaignStatus {
    ACTIVE= 'active',
    EXPIRE= 'expired',
    INACTIVE= 'inactive',
    SCHEDULED= 'upcoming',
};